module.exports = __webpack_public_path__ + "static/hero-c6374cf4025d428ff72359f30d630571.jpg";